module.exports = __webpack_public_path__ + "img/croix.3b6ac7bd.svg";